module.exports = __webpack_public_path__ + "static/PolicingEquity-36e7cefa9d25dedb9775814d35b58ca6.png";